<template>
    <div class="content">
      <h1>Other Games</h1>
      <p>Placeholder.</p>

      <h2>Fortnite Tools</h2>
      <p>
        A collection of tools for Fortnite players in the squad.
      </p>
      <ul>
        <li>
          <a href="/fortnite-sprite-trader.html" target="_blank" rel="noopener">
            🎨 Fortnite Spray Trader
          </a>
          — Track your spray (sprite) collection and compare with squad members to find trade opportunities, including 3-way trades.
        </li>
      </ul>
    </div>

</template>


